import { playHaptic } from '../haptics';
import { stopResultSounds } from '../sounds';

const img = (name) => `${process.env.PUBLIC_URL}/img/${name}`;

export function GameHeader({ title, icon, onExit }) {
  return (
    <header className="screen-header">
      <button
        type="button"
        className="icon-btn"
        data-cuelume-press
        data-cuelume-release="droplet"
        onClick={() => {
          playHaptic('selection');
          onExit();
        }}
        aria-label="Назад"
      >
        <img src={img('icon-arrow-left.svg')} alt="" draggable="false" />
      </button>
      <h1 className="screen-title">{title}</h1>
      <span className="icon-btn static" aria-hidden="true">
        {icon.startsWith('ri-') ? (
          <i className={icon} />
        ) : (
          <img src={img(icon)} alt="" draggable="false" />
        )}
      </span>
    </header>
  );
}

export function ResultSticker({ won, winVideo }) {
  if (won && winVideo) {
    return (
      <video
        className="result-sticker"
        src={img(winVideo)}
        autoPlay
        loop
        muted
        playsInline
        aria-hidden="true"
      />
    );
  }

  return (
    <img
      className="result-sticker"
      src={img(won ? 'sticker-win.webp' : 'sticker-fail.webp')}
      alt=""
      draggable="false"
    />
  );
}

export function ResultActions({ onRestart, restartLabel = 'Играть снова', onHome }) {
  return (
    <div className="result-actions">
      <button
        type="button"
        className="restart"
        data-cuelume-press="pulse"
        data-cuelume-release="bloom"
        onClick={onRestart}
      >
        {restartLabel}
      </button>
      <button
        type="button"
        className="home-btn"
        data-cuelume-press
        data-cuelume-release="droplet"
        onClick={() => {
          stopResultSounds();
          playHaptic('selection');
          onHome();
        }}
      >
        На главную
      </button>
    </div>
  );
}
